import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';

import {
  canAddJob,
  canImportJobFromSAP,
} from '../../utils/permissions';

import {
  getMyJobs,
  getOtherJobs,
  tagJob,
} from '../../actions/jobs';

import Jobs from '../../components/Jobs/Jobs';
import FilterJobs from '../../components/FilterJobs/FilterJobs';
import ImportIcon from '@material-ui/icons/GetApp'

import {
  Drawer,
} from '../../components/base';

const styles = theme => ({
  linkContainer: {
    width: '100%',
    height: 64,
    display: 'flex',
    justifyContent: 'flex-end',
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
    pointerEvents: 'none',

    [theme.breakpoints.up('sm')]: {
      bottom: theme.spacing(4),
      right: theme.spacing(4),
      height: 72,
    },
  },
  button: {
    textDecoration: 'none',
    fontSize: 26,
    height: 64,
    width: 64,
    background: theme.palette.secondary.main,
    color: theme.palette.primary.main,
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    pointerEvents: 'auto',

    '&:not(:last-child)': {
      marginRight: theme.spacing(2),
    },

    '&:hover': {
      background: theme.palette.secondary.dark,
      transition: 'all 0.5s',
    },

    [theme.breakpoints.up('sm')]: {
      height: 72,
      width: 72,

      '&:not(:last-child)': {
        marginRight: theme.spacing(4),
      },
    },
  },
})

class JobsView extends Component {
  state = {
    sidebarOpen: false,
  }

  async componentDidMount() {
    const { sorting, filter, user, actions } = this.props;
    const filters = { sort: { jobDate: sorting }, filter: this.props.filter };
    const defaultFilters = JSON.parse(JSON.stringify(filters));
    const defaultFiltersKeys = user && user.defaultFilter && Object.keys(user.defaultFilter);

    defaultFiltersKeys !== null && defaultFiltersKeys.map(filter => {
      if (filter === 'numberOfDays' && user.defaultFilter.numberOfDays) {
        defaultFilters.filter.jobDateTo = new Date();
        defaultFilters.filter.jobDateFrom = new Date();
        defaultFilters.filter.jobDateFrom.setDate(defaultFilters.filter.jobDateFrom.getDate() - user.defaultFilter.numberOfDays);
      }

      if (filter === 'finalReportReleased' && user.defaultFilter && user.defaultFilter[filter] === 'FULFILLED') {
        defaultFilters.filter.status[filter] = user.defaultFilter[filter];
      }

      defaultFilters.filter[filter] = user.defaultFilter[filter];

      return true;
    })

    try {
      if (filter.isFirstRender && user.defaultFilter !== null) {
        defaultFilters.filter.isFirstRender = false;
        await actions.getMyJobs(defaultFilters);
        await actions.getOtherJobs(defaultFilters);
      } else {
        filters.filter.isFirstRender = false;
        await actions.getMyJobs(filters);
        await actions.getOtherJobs(filters);
      }

    } catch (e) {

    }
  }

  openSidebar = e => this.setState({sidebarOpen: true})

  closeSidebar = e => this.setState({sidebarOpen: false})

  handleTagJob = (jobId, data) => {
    try {
      this.props.actions.tagJob(jobId, data)
    } catch (e) {
      // Handle error
    }
  }

  onPaginationClick = async (jobsType, offset, packData) => {
    const filters = { sort: { jobDate: this.props.sorting }, filter: this.props.filter };
    return jobsType === 'myJobs'
      ? await this.props.actions.getMyJobs(filters, 10, packData || 'yes')
      : await this.props.actions.getOtherJobs(filters, 10, packData || 'yes')
  }

  render() {
    const { myJobs, otherJobs, totalMyJobs, totalOtherJobs, sorting, user, classes: c } = this.props;

    return (
      <Fragment>
        <Drawer
          anchor='right'
          open={this.state.sidebarOpen}
          onClose={this.closeSidebar}
        >
          <FilterJobs
            onCloseClick={this.closeSidebar}
          />
        </Drawer>
        <Jobs
          myJobs={myJobs}
          otherJobs={otherJobs}
          sorting={sorting}
          totalMyJobs={totalMyJobs}
          totalOtherJobs={totalOtherJobs}
          handleTagJob={this.handleTagJob}
          handleFiltersClick={this.openSidebar}
          onPaginationClick={this.onPaginationClick}
        />
        <div className={c.linkContainer}>
          {
            canImportJobFromSAP(user) &&
            <Link to='/import-job' variant='contained' color='secondary' className={c.button}><ImportIcon /></Link>
          }
          {
            canAddJob(user) &&
            <Link to='/add-job' className={c.button}>+</Link>
          }
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  myJobs: state.jobs.myJobs.results,
  otherJobs: state.jobs.otherJobs.results,
  sorting: state.jobs.sort.jobDate,
  filter: state.jobs.filter,
  totalMyJobs: state.jobs.myJobs.total,
  totalOtherJobs: state.jobs.otherJobs.total,
  user: state.user,
});

const mapDispatchToProps = dispatch => ({
  actions: {
    getMyJobs: bindActionCreators(getMyJobs, dispatch),
    getOtherJobs: bindActionCreators(getOtherJobs, dispatch),
    tagJob: bindActionCreators(tagJob, dispatch),
  }
});

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(JobsView));



// WEBPACK FOOTER //
// ./src/views/Jobs/JobsView.js